module.exports = __webpack_public_path__ + "img/symbol_3.ede992c5.png";